import { render, staticRenderFns } from "./CommentDots.vue?vue&type=template&id=dddca6f4"
import script from "./CommentDots.vue?vue&type=script&lang=js"
export * from "./CommentDots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports